/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Index_Searchbutton1Inputs */

const id_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const ms_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const da_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg`)
};

const de_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen`)
};

const en_us2_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_es2_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_mx2_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fil_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap`)
};

const fr_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const it_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const hu_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés`)
};

const nl_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken`)
};

const no_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk`)
};

const pl_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj`)
};

const pt_br2_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar`)
};

const pt_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ro_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare`)
};

const fi_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae`)
};

const sv_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök`)
};

const vi_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

const tr_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara`)
};

const cs_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const bg_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене`)
};

const ru_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const uk_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук`)
};

const ar_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const hi_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज`)
};

const th_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา`)
};

const ja_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_cn2_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const zh_hant1_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋`)
};

const ko_changelog_index_searchbutton1 = /** @type {(inputs: Changelog_Index_Searchbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Changelog_Index_Searchbutton1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_index_searchbutton1 = /** @type {((inputs?: Changelog_Index_Searchbutton1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Index_Searchbutton1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_index_searchbutton1(inputs)
	if (locale === "ms") return ms_changelog_index_searchbutton1(inputs)
	if (locale === "da") return da_changelog_index_searchbutton1(inputs)
	if (locale === "de") return de_changelog_index_searchbutton1(inputs)
	if (locale === "en-US") return en_us2_changelog_index_searchbutton1(inputs)
	if (locale === "es-ES") return es_es2_changelog_index_searchbutton1(inputs)
	if (locale === "es-MX") return es_mx2_changelog_index_searchbutton1(inputs)
	if (locale === "fil") return fil_changelog_index_searchbutton1(inputs)
	if (locale === "fr") return fr_changelog_index_searchbutton1(inputs)
	if (locale === "it") return it_changelog_index_searchbutton1(inputs)
	if (locale === "hu") return hu_changelog_index_searchbutton1(inputs)
	if (locale === "nl") return nl_changelog_index_searchbutton1(inputs)
	if (locale === "no") return no_changelog_index_searchbutton1(inputs)
	if (locale === "pl") return pl_changelog_index_searchbutton1(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_index_searchbutton1(inputs)
	if (locale === "pt") return pt_changelog_index_searchbutton1(inputs)
	if (locale === "ro") return ro_changelog_index_searchbutton1(inputs)
	if (locale === "fi") return fi_changelog_index_searchbutton1(inputs)
	if (locale === "sv") return sv_changelog_index_searchbutton1(inputs)
	if (locale === "vi") return vi_changelog_index_searchbutton1(inputs)
	if (locale === "tr") return tr_changelog_index_searchbutton1(inputs)
	if (locale === "cs") return cs_changelog_index_searchbutton1(inputs)
	if (locale === "bg") return bg_changelog_index_searchbutton1(inputs)
	if (locale === "ru") return ru_changelog_index_searchbutton1(inputs)
	if (locale === "uk") return uk_changelog_index_searchbutton1(inputs)
	if (locale === "ar") return ar_changelog_index_searchbutton1(inputs)
	if (locale === "hi") return hi_changelog_index_searchbutton1(inputs)
	if (locale === "th") return th_changelog_index_searchbutton1(inputs)
	if (locale === "ja") return ja_changelog_index_searchbutton1(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_index_searchbutton1(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_index_searchbutton1(inputs)
	return ko_changelog_index_searchbutton1(inputs)
});
export { changelog_index_searchbutton1 as "changelog.index.searchButton" }